import { ReactNode } from "react";

import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import Button from "src/components/Button";
import Spinner from "src/components/Spinner";

interface LoadingDialogProps {
  open: boolean;
  title: ReactNode;
  children: ReactNode;
  loading: boolean;
  loadingMessage?: string;
  closeLabel: string;
  onClose: () => void;
  maxWidth?: DialogProps["maxWidth"];
  disableRestoreFocus?: boolean;
}

const LoadingDialog = ({
  open,
  title,
  children,
  loading,
  loadingMessage,
  closeLabel,
  onClose,
  maxWidth = "md",
  disableRestoreFocus,
}: LoadingDialogProps) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={maxWidth}
    fullWidth={!loading}
    disableRestoreFocus={disableRestoreFocus}
    slotProps={{
      paper: {
        sx: {
          width: loading ? 360 : undefined,
          height: loading ? 380 : undefined,
          maxWidth: loading ? "calc(100% - 32px)" : undefined,
          maxHeight: loading ? "calc(100% - 32px)" : undefined,
          display: "flex",
          flexDirection: "column",
          transition: (theme) =>
            theme.transitions.create(["width", "max-width", "height", "max-height"], {
              duration: theme.transitions.duration.standard,
              easing: theme.transitions.easing.easeInOut,
            }),
        },
      },
    }}
  >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent
      sx={{
        flex: loading ? 1 : undefined,
        minHeight: loading ? 0 : undefined,
        overflowY: loading ? "hidden" : "auto",
        display: loading ? "flex" : undefined,
        alignItems: loading ? "center" : undefined,
        justifyContent: loading ? "center" : undefined,
        transition: (theme) =>
          theme.transitions.create(["min-height", "height"], {
            duration: theme.transitions.duration.standard,
            easing: theme.transitions.easing.easeInOut,
          }),
      }}
    >
      {loading ? <Spinner message={loadingMessage} size="small" variant="inline" /> : children}
    </DialogContent>
    <DialogActions sx={{ p: 3, flexShrink: 0, "& .MuiButton-root": { mr: "0 !important" } }}>
      <Button onClick={onClose}>{closeLabel}</Button>
    </DialogActions>
  </Dialog>
);

export default LoadingDialog;
